import React from 'react';
import { useTranslation } from 'react-i18next';
import './DocumentComparison.css'; // Импортируем стили

function DocumentComparison({ documentResult }) {
  const { t } = useTranslation();
  // Sort sections by their index to maintain the original order
  const sortedSections = [...documentResult.result].sort((a, b) => {
    const indexA = a.index ?? 0;
    const indexB = b.index ?? 0;
    return indexA - indexB;
  });

  return (
    <div className="doccomparison__container">
      <div className="doccomparison__header">
        <h3>{t('comparison.original')}</h3>
        {documentResult.result.some(section => section.translation !== null) && (
          <h3>{t('comparison.translation')}</h3>
        )}
        <h3>{t('comparison.simplified')}</h3>
      </div>
      <div className="doccomparison__content">
        {sortedSections.map((section, index) => {
          const hasTranslation = section.translation !== null;
          return (
            <div 
              key={index} 
              className={`doccomparison__row ${hasTranslation ? 'three-columns' : 'two-columns'}`}
            >
              <div className="doccomparison__cell original">{section.original}</div>
              {hasTranslation && (
                <div className="doccomparison__cell translation">{section.translation}</div>
              )}
              <div className="doccomparison__cell simplified">{section.simplified}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DocumentComparison; 
